import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">海量内容，满足你的每一种喜好</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all duration-300"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-100/80 text-accent-600 group-hover:bg-primary-100 group-hover:text-primary-500 transition-all duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">{cat.name}</h3>
                <p className="text-xs text-foreground-400">{cat.count}部作品</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}